import dayjs from 'dayjs';

import { ConvertableToDateTime } from '@cast/shared-types';

export type OomKillDataPoint = {
  timestamp: string;
  managedCount: number | null;
  unmanagedCount: number | null;
  totalCount: number | null;
};

export const createOomKillFiller =
  () =>
  (timestamp: ConvertableToDateTime): OomKillDataPoint => ({
    timestamp: dayjs(timestamp).toISOString(),
    managedCount: null,
    unmanagedCount: null,
    totalCount: null,
  });

export const mergeOomKillDataPoints = (
  items: OomKillDataPoint[]
): OomKillDataPoint[] => {
  const byTimestamp = new Map<string, OomKillDataPoint>();

  for (const item of items) {
    const existing = byTimestamp.get(item.timestamp) ?? {
      timestamp: item.timestamp,
      managedCount: null,
      unmanagedCount: null,
      totalCount: null,
    };

    byTimestamp.set(item.timestamp, {
      timestamp: item.timestamp,
      managedCount: item.managedCount ?? existing.managedCount,
      unmanagedCount: item.unmanagedCount ?? existing.unmanagedCount,
      totalCount: item.totalCount ?? existing.totalCount,
    });
  }

  return [...byTimestamp.values()].sort((a, b) =>
    dayjs(a.timestamp).isAfter(b.timestamp) ? 1 : -1
  );
};
